var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 14.105C17.5193 11.2016 20.0528 7.38716 18.5672 5.71411C18.096 5.18375 17.4381 4.93782 16.7316 5.01338C16.1385 5.07825 15.5291 5.37123 14.9146 5.86309C13.9487 5.36267 12.8705 5.11838 11.7832 5.15358C10.6959 5.18877 9.63583 5.50228 8.70428 6.06411C7.9801 6.49287 7.34828 7.06117 6.84547 7.73604C6.34266 8.4109 5.97886 9.17889 5.77519 9.99546C5.45776 11.2533 5.5339 12.5782 5.99333 13.7914C5.23414 14.6489 4.52914 16.4125 5.40665 17.4005C5.77519 17.8147 6.3027 18 6.93713 18C8.86681 18 11.7902 16.2899 14.2495 14.105ZM16.8863 6.4298C17.1415 6.40557 17.3368 6.47543 17.5001 6.66005C17.6647 6.84611 17.6205 7.3344 17.3204 8.03513C16.998 7.54448 16.6103 7.10009 16.1678 6.71423C16.475 6.52746 16.7209 6.44834 16.8863 6.4298ZM6.74181 15.1999C7.05879 15.6597 7.43456 16.0759 7.85956 16.4382C7.12889 16.6541 6.63774 16.6399 6.47307 16.4531C6.31838 16.2799 6.4745 15.6911 6.74181 15.1999ZM18.3683 11.0163C17.5022 12.2972 16.2968 13.6331 14.9623 14.8179C13.5837 16.0432 12.0639 17.1047 10.6496 17.8132C11.0885 17.9098 11.5362 17.9605 11.9855 17.9644C13.1448 17.9631 14.2821 17.6473 15.276 17.0505C16.3085 16.4392 17.1469 15.5481 17.6942 14.4802C18.2414 13.4124 18.4751 12.2114 18.3683 11.0163Z",
    fill: "#2d2d2d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.881e16b8b97af4c351fc5518e782d5ff.svg";
export { ForwardRef as ReactComponent };